import React from 'react';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { Grid, Typography, Button } from '@material-ui/core';

import { updateDetailSettings } from 'Console/data/applicationDetail/settings/SettingsAction';

import { selectApplicationMultiTenant } from 'Console/data/applicationDetail/settings/SettingsSelector';

import FormInput from 'Console/components/common/form/FormInput';

const styles = (theme) => ({
    root: {
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        'font-weight': 'bold',
        'padding-bottom': theme.typography.pxToRem(20),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.typography.pxToRem(34),
    },
    btn: {
        marginBottom: theme.typography.pxToRem(65),
        marginTop: theme.typography.pxToRem(20),
    },
    formInput: {
        width: '33%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});

const Multitenancy = ({ classes, intl, form, updateDetailSettings, multiTenant }) => {
    const handleSaveMultitenancySettings = () => {
        const { pattern } = form.getFieldValue('multitenancy');
        updateDetailSettings(
            {
                'multiTenant.pattern': pattern,
            },
            {
                success: `${intl.formatMessage({ id: 'Notification.save' })}`,
                fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
            }
        );
    };

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <Grid item>
                    <Typography variant="subtitle1" className={classes.title}>
                        {intl.formatMessage({ id: 'Settings.multitenancy.multiTenancy' })}
                    </Typography>
                </Grid>

                <Grid item>
                    <Typography variant="body1" className={classes.message}>
                        {intl.formatMessage({ id: 'Settings.multitenancy.message' })}
                    </Typography>
                </Grid>

                <Grid className={classes.formInput}>
                    <FormInput
                        fullWidth={false}
                        form={form}
                        type="text"
                        formItemKey="multitenancy.pattern"
                        initialValue={get(multiTenant, 'pattern')}
                        placeholder={intl.formatMessage({ id: 'Settings.multitenancy.label' })}
                    />
                </Grid>

                <Grid container alignItems="center">
                    <Typography variant="button">
                        <Button
                            id="yeself-button"
                            variant="contained"
                            color="primary"
                            onClick={handleSaveMultitenancySettings}
                            className={classes.btn}
                        >
                            {intl.formatMessage({ id: 'Buttons.save' })}
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(
    connect(
        (state) => ({
            multiTenant: selectApplicationMultiTenant(state),
        }),
        { updateDetailSettings }
    )(injectIntl(Multitenancy))
);
